import React, { useState } from 'react';
import "../olddata.css";


const OldData = () => {
  const [filters, setFilters] = useState({
    project: '',
    year: '',
    month: '',
    brand: '',
    report: '',
  });

  //BUNLAR OK
  const auditFiles = [
    "GenelRapor_BayiDenetim_Peugeot_Ekipman_BEV_4_Donem_2023.xlsx",
    "GenelRapor_BayiDenetim_Peugeot_Ekipman_Elektrik_Elektronik_Mekanik_4_Donem_2023.xlsx",
    "GenelRapor_BayiDenetim_Peugeot_Ekipman_Kaporta_Boya_4_Donem_2023.xlsx",
    "GenelRapor_BayiDenetim_Peugeot_Ekipman_Ön_Düzen-Araç_Kabul_Yikama_4_Donem_2023.xlsx",
    "GenelRapor_BayiDenetim_Peugeot_Ekipman_Özel_Takim_4_Donem_2023.xlsx",
    "GenelRapor_BayiDenetim_Peugeot_Satis_IK_4_Donem_2023.xlsx",
    "GenelRapor_BayiDenetim_Peugeot_Satis_Maddi_4_Donem_2023.xlsx",
    "GenelRapor_BayiDenetim_Peugeot_Satis_Peugeot_Profesyonel_4_Donem_2023.xlsx",
    "GenelRapor_BayiDenetim_Peugeot_Satis_SOS_2023_4_Donem_2023.xlsx",
    "GenelRapor_BayiDenetim_Peugeot_Satis_Toplu_4_Donem_2023.xlsx",
    "GenelRapor_BayiDenetim_Peugeot_Servis_Toplu_4_Donem_2023.xlsx",
  ];

  //BUNLAR OK
  const euroreparReports = {
    2021: {
      8: [
        "Eurorepar_Data_Turkiye_Servis_Agustos_Aylik_2021.xlsx",
        "Eurorepar_GenelRapor_Servis_Agustos_Aylik_2021.xlsx",
      ],
      9: [
        "Eurorepar_Data_Turkiye_Servis_Eylul_Aylik_2021.xlsx",
        "Eurorepar_GenelRapor_Servis_Eylul_Aylik_2021.xlsx",
      ],
      10: [
        "Eurorepar_Data_Turkiye_Servis_Ekim_Aylik_2021.xlsx",
        "Eurorepar_GenelRapor_Servis_Ekim_Aylik_2021.xlsx",
      ],
      11: [
        "Eurorepar_Data_Turkiye_Servis_Kasim_Aylik_2021.xlsx",
        "Eurorepar_GenelRapor_Servis_Kasim_Aylik_2021.xlsx",
      ],
      12: [
        "Eurorepar_Data_Turkiye_Servis_Aralik_Aylik_2021.xlsx",
        "Eurorepar_GenelRapor_Servis_Aralik_Aylik_2021.xlsx",
      ],
    },
    2022: {
      1: [
        "Eurorepar_Data_Turkiye_Servis_Ocak_Aylik_2022.xlsx",
        "Eurorepar_GenelRapor_Servis_Ocak_Aylik_2022.xlsx",
      ],
      2: [
        "Eurorepar_Data_Turkiye_Servis_Subat_Aylik_2022.xlsx",
        "Eurorepar_GenelRapor_Servis_Subat_Aylik_2022.xlsx",
      ],
      3: [
        "Eurorepar_Data_Turkiye_Servis_Mart_Aylik_2022.xlsx",
        "Eurorepar_GenelRapor_Servis_Mart_Aylik_2022.xlsx",
      ],
      4: [
        "Eurorepar_Data_Turkiye_Servis_Nisan_Aylik_2022.xlsx",
        "Eurorepar_GenelRapor_Servis_Nisan_Aylik_2022.xlsx",
      ],
      5: [
        "Eurorepar_Data_Turkiye_Servis_Mayis_Aylik_2022.xlsx",
        "Eurorepar_GenelRapor_Servis_Mayis_Aylik_2022.xlsx",
      ],
      6: [
        "Eurorepar_Data_Turkiye_Servis_Haziran_Aylik_2022.xlsx",
        "Eurorepar_GenelRapor_Servis_Haziran_Aylik_2022.xlsx",
      ],
      7: [
        "Eurorepar_Data_Turkiye_Servis_Temmuz_Aylik_2022.xlsx",
        "Eurorepar_GenelRapor_Servis_Temmuz_Aylik_2022.xlsx",
      ],
      8: [
        "Eurorepar_Data_Turkiye_Servis_Agustos_Aylik_2022.xlsx",
        "Eurorepar_GenelRapor_Servis_Agustos_Aylik_2022.xlsx",
      ],
      9: [
        "Eurorepar_Data_Turkiye_Servis_Eylul_Aylik_2022.xlsx",
        "Eurorepar_GenelRapor_Servis_Eylul_Aylik_2022.xlsx",
      ],
      10: [
        "Eurorepar_Data_Turkiye_Servis_Ekim_Aylik_2022.xlsx",
        "Eurorepar_GenelRapor_Servis_Ekim_Aylik_2022.xlsx",
      ],
      11: [
        "Eurorepar_Data_Turkiye_Servis_Kasim_Aylik_2022.xlsx",
        "Eurorepar_GenelRapor_Servis_Kasim_Aylik_2022.xlsx",
      ],
      12: [
        "Eurorepar_Data_Turkiye_Servis_Aralik_Aylik_2022.xlsx",
        "Eurorepar_GenelRapor_Servis_Aralik_Aylik_2022.xlsx",
      ],
    },
    2023: {
      1: [
        "Eurorepar_Data_Turkiye_Servis_Ocak_Aylik_2023.xlsx",
        "Eurorepar_GenelRapor_Servis_Ocak_Aylik_2023.xlsx",
      ],
      2: [
        "Eurorepar_Data_Turkiye_Servis_Subat_Aylik_2023.xlsx",
        "Eurorepar_GenelRapor_Servis_Subat_Aylik_2023.xlsx",
      ],
      3: [
        "Eurorepar_Data_Turkiye_Servis_Mart_Aylik_2023.xlsx",
        "Eurorepar_GenelRapor_Servis_Mart_Aylik_2023.xlsx",
      ],
      4: [
        "Eurorepar_Data_Turkiye_Servis_Nisan_Aylik_2023.xlsx",
        "Eurorepar_GenelRapor_Servis_Nisan_Aylik_2023.xlsx",
      ],
      5: [
        "Eurorepar_Data_Turkiye_Servis_Mayis_Aylik_2023.xlsx",
        "Eurorepar_GenelRapor_Servis_Mayis_Aylik_2023.xlsx",
      ],
      6: [
        "Eurorepar_Data_Turkiye_Servis_Haziran_Aylik_2023.xlsx",
        "Eurorepar_GenelRapor_Servis_Haziran_Aylik_2023.xlsx",
      ],
      7: [
        "Eurorepar_Data_Turkiye_Servis_Temmuz_Aylik_2023.xlsx",
        "Eurorepar_GenelRapor_Servis_Temmuz_Aylik_2023.xlsx",
      ],
      8: [
        "Eurorepar_Data_Turkiye_Servis_Agustos_Aylik_2023.xlsx",
        "Eurorepar_GenelRapor_Servis_Agustos_Aylik_2023.xlsx",
      ],
      9: [
        "Eurorepar_Data_Turkiye_Servis_Eylul_Aylik_2023.xlsx",
        "Eurorepar_GenelRapor_Servis_Eylul_Aylik_2023.xlsx",
      ],
      10: [
        "Eurorepar_Data_Turkiye_Servis_Ekim_Aylik_2023.xlsx",
        "Eurorepar_GenelRapor_Servis_Ekim_Aylik_2023.xlsx",
      ],
      11: [
        "Eurorepar_Data_Turkiye_Servis_Kasim_Aylik_2023.xlsx",
        "Eurorepar_GenelRapor_Servis_Kasim_Aylik_2023.xlsx",
      ],
      12: [
        "Eurorepar_Data_Turkiye_Servis_Aralik_Aylik_2023.xlsx",
        "Eurorepar_GenelRapor_Servis_Aralik_Aylik_2023.xlsx",
      ],
    },
  };
  

  //BUNLAR OK
  const gizliMusteriTelefonReports = {
    "Citroen": {
      2021: {
        2: "Citroen_Satis_Telefon_Subat_2021.xlsx",
        3: "Citroen_Satis_Telefon_Mart_2021.xlsx",
        4: "Citroen_Satis_Telefon_Nisan_2021.xlsx",
        5: "Citroen_Satis_Telefon_Mayis_2021.xlsx",
        6: "Citroen_Satis_Telefon_Haziran_2021.xlsx",
        7: "Citroen_Satis_Telefon_Temmuz_2021.xlsx",
        8: "Citroen_Satis_Telefon_Agustos_2021.xlsx",
        9: "Citroen_Satis_Telefon_Eylul_2021.xlsx",
        10: "Citroen_Satis_Telefon_Ekim_2021.xlsx",
        11: "Citroen_Satis_Telefon_Kasim_2021.xlsx",
        12: "Citroen_Satis_Telefon_Aralik_2021.xlsx",
      },
      2022: {
        1: "Citroen_Satis_Telefon_Ocak_2022.xlsx",
        2: "Citroen_Satis_Telefon_Subat_2022.xlsx",
        3: "Citroen_Satis_Telefon_Mart_2022.xlsx",
        4: "Citroen_Satis_Telefon_Nisan_2022.xlsx",
        5: "Citroen_Satis_Telefon_Mayis_2022.xlsx",
        6: "Citroen_Satis_Telefon_Haziran_2022.xlsx",
        7: "Citroen_Satis_Telefon_Temmuz_2022.xlsx",
        8: "Citroen_Satis_Telefon_Agustos_2022.xlsx",
        9: "Citroen_Satis_Telefon_Eylul_2022.xlsx",
        10: "Citroen_Satis_Telefon_Ekim_2022.xlsx",
        11: "Citroen_Satis_Telefon_Kasim_2022.xlsx",
        12: "Citroen_Satis_Telefon_Aralik_2022.xlsx",
      },
      2023: {
        1: "Citroen_Satis_Telefon_Ocak_2023.xlsx",
        2: "Citroen_Satis_Telefon_Subat_2023.xlsx",
        3: "Citroen_Satis_Telefon_Mart_2023.xlsx",
        4: "Citroen_Satis_Telefon_Nisan_2023.xlsx",
        5: "Citroen_Satis_Telefon_Mayis_2023.xlsx",
        6: "Citroen_Satis_Telefon_Haziran_2023.xlsx",
        7: "Citroen_Satis_Telefon_Temmuz_2023.xlsx",
        8: "Citroen_Satis_Telefon_Agustos_2023.xlsx",
        9: "Citroen_Satis_Telefon_Eylul_2023.xlsx",
        10: "Citroen_Satis_Telefon_Ekim_2023.xlsx",
        11: "Citroen_Satis_Telefon_Kasim_2023.xlsx",
        12: "Citroen_Satis_Telefon_Aralik_2023.xlsx",
      },
    },
    "Peugeot": {
      2021: {
        2: "Peugeot_Satis_Telefon_Subat_2021.xlsx",
        3: "Peugeot_Satis_Telefon_Mart_2021.xlsx",
        4: "Peugeot_Satis_Telefon_Nisan_2021.xlsx",
        5: "Peugeot_Satis_Telefon_Mayis_2021.xlsx",
        6: "Peugeot_Satis_Telefon_Haziran_2021.xlsx",
        7: "Peugeot_Satis_Telefon_Temmuz_2021.xlsx",
        8: "Peugeot_Satis_Telefon_Agustos_2021.xlsx",
        9: "Peugeot_Satis_Telefon_Eylul_2021.xlsx",
        10: "Peugeot_Satis_Telefon_Ekim_2021.xlsx",
        11: "Peugeot_Satis_Telefon_Kasim_2021.xlsx",
        12: "Peugeot_Satis_Telefon_Aralik_2021.xlsx",
      },
      2022: {
        1: "Peugeot_Satis_Telefon_Ocak_2022.xlsx",
        2: "Peugeot_Satis_Telefon_Subat_2022.xlsx",
        3: "Peugeot_Satis_Telefon_Mart_2022.xlsx",
        4: "Peugeot_Satis_Telefon_Nisan_2022.xlsx",
        5: "Peugeot_Satis_Telefon_Mayis_2022.xlsx",
        6: "Peugeot_Satis_Telefon_Haziran_2022.xlsx",
        7: "Peugeot_Satis_Telefon_Temmuz_2022.xlsx",
        8: "Peugeot_Satis_Telefon_Agustos_2022.xlsx",
        9: "Peugeot_Satis_Telefon_Eylul_2022.xlsx",
        10: "Peugeot_Satis_Telefon_Ekim_2022.xlsx",
        11: "Peugeot_Satis_Telefon_Kasim_2022.xlsx",
        12: "Peugeot_Satis_Telefon_Aralik_2022.xlsx",
      },
      2023: {
        1: "Peugeot_Satis_Telefon_Ocak_2023.xlsx",
        2: "Peugeot_Satis_Telefon_Subat_2023.xlsx",
        3: "Peugeot_Satis_Telefon_Mart_2023.xlsx",
        4: "Peugeot_Satis_Telefon_Nisan_2023.xlsx",
        5: "Peugeot_Satis_Telefon_Mayis_2023.xlsx",
        6: "Peugeot_Satis_Telefon_Haziran_2023.xlsx",
        7: "Peugeot_Satis_Telefon_Temmuz_2023.xlsx",
        8: "Peugeot_Satis_Telefon_Agustos_2023.xlsx",
        9: "Peugeot_Satis_Telefon_Eylul_2023.xlsx",
        10: "Peugeot_Satis_Telefon_Ekim_2023.xlsx",
        11: "Peugeot_Satis_Telefon_Kasim_2023.xlsx",
        12: "Peugeot_Satis_Telefon_Aralik_2023.xlsx",
      },
    },
    "Opel": {
      2021: {
        2: "Opel_Satis_Telefon_Subat_2021.xlsx",
        3: "Opel_Satis_Telefon_Mart_2021.xlsx",
        4: "Opel_Satis_Telefon_Nisan_2021.xlsx",
        5: "Opel_Satis_Telefon_Mayis_2021.xlsx",
        6: "Opel_Satis_Telefon_Haziran_2021.xlsx",
        7: "Opel_Satis_Telefon_Temmuz_2021.xlsx",
        8: "Opel_Satis_Telefon_Agustos_2021.xlsx",
        9: "Opel_Satis_Telefon_Eylul_2021.xlsx",
        10: "Opel_Satis_Telefon_Ekim_2021.xlsx",
        11: "Opel_Satis_Telefon_Kasim_2021.xlsx",
        12: "Opel_Satis_Telefon_Aralik_2021.xlsx",
      },
      2022: {
        1: "Opel_Satis_Telefon_Ocak_2022.xlsx",
        2: "Opel_Satis_Telefon_Subat_2022.xlsx",
        3: "Opel_Satis_Telefon_Mart_2022.xlsx",
        4: "Opel_Satis_Telefon_Nisan_2022.xlsx",
        5: "Opel_Satis_Telefon_Mayis_2022.xlsx",
        6: "Opel_Satis_Telefon_Haziran_2022.xlsx",
        7: "Opel_Satis_Telefon_Temmuz_2022.xlsx",
        8: "Opel_Satis_Telefon_Agustos_2022.xlsx",
        9: "Opel_Satis_Telefon_Eylul_2022.xlsx",
        10: "Opel_Satis_Telefon_Ekim_2022.xlsx",
        11: "Opel_Satis_Telefon_Kasim_2022.xlsx",
        12: "Opel_Satis_Telefon_Aralik_2022.xlsx",
      },
      2023: {
        1: "Opel_Satis_Telefon_Ocak_2023.xlsx",
        2: "Opel_Satis_Telefon_Subat_2023.xlsx",
        3: "Opel_Satis_Telefon_Mart_2023.xlsx",
        4: "Opel_Satis_Telefon_Nisan_2023.xlsx",
        5: "Opel_Satis_Telefon_Mayis_2023.xlsx",
        6: "Opel_Satis_Telefon_Haziran_2023.xlsx",
        7: "Opel_Satis_Telefon_Temmuz_2023.xlsx",
        8: "Opel_Satis_Telefon_Agustos_2023.xlsx",
        9: "Opel_Satis_Telefon_Eylul_2023.xlsx",
        10: "Opel_Satis_Telefon_Ekim_2023.xlsx",
        11: "Opel_Satis_Telefon_Kasim_2023.xlsx",
        12: "Opel_Satis_Telefon_Aralik_2023.xlsx",
      },
    },
    "DS": {
      2021: {
        2: "DS_Satis_Telefon_Subat_2021.xlsx",
        3: "DS_Satis_Telefon_Mart_2021.xlsx",
        4: "DS_Satis_Telefon_Nisan_2021.xlsx",
        5: "DS_Satis_Telefon_Mayis_2021.xlsx",
        6: "DS_Satis_Telefon_Haziran_2021.xlsx",
        7: "DS_Satis_Telefon_Temmuz_2021.xlsx",
        8: "DS_Satis_Telefon_Agustos_2021.xlsx",
        9: "DS_Satis_Telefon_Eylul_2021.xlsx",
        10: "DS_Satis_Telefon_Ekim_2021.xlsx",
        11: "DS_Satis_Telefon_Kasim_2021.xlsx",
        12: "DS_Satis_Telefon_Aralik_2021.xlsx",
      },
      2022: {
        1: "DS_Satis_Telefon_Ocak_2022.xlsx",
        2: "DS_Satis_Telefon_Subat_2022.xlsx",
        3: "DS_Satis_Telefon_Mart_2022.xlsx",
        4: "DS_Satis_Telefon_Nisan_2022.xlsx",
        5: "DS_Satis_Telefon_Mayis_2022.xlsx",
        6: "DS_Satis_Telefon_Haziran_2022.xlsx",
        7: "DS_Satis_Telefon_Temmuz_2022.xlsx",
        8: "DS_Satis_Telefon_Agustos_2022.xlsx",
        9: "DS_Satis_Telefon_Eylul_2022.xlsx",
        10: "DS_Satis_Telefon_Ekim_2022.xlsx",
        11: "DS_Satis_Telefon_Kasim_2022.xlsx",
        12: "DS_Satis_Telefon_Aralik_2022.xlsx",
      },
      2023: {
        1: "DS_Satis_Telefon_Ocak_2023.xlsx",
        2: "DS_Satis_Telefon_Subat_2023.xlsx",
        3: "DS_Satis_Telefon_Mart_2023.xlsx",
        4: "DS_Satis_Telefon_Nisan_2023.xlsx",
        5: "DS_Satis_Telefon_Mayis_2023.xlsx",
        6: "DS_Satis_Telefon_Haziran_2023.xlsx",
        7: "DS_Satis_Telefon_Temmuz_2023.xlsx",
        8: "DS_Satis_Telefon_Agustos_2023.xlsx",
        9: "DS_Satis_Telefon_Eylul_2023.xlsx",
        10: "DS_Satis_Telefon_Ekim_2023.xlsx",
        11: "DS_Satis_Telefon_Kasim_2023.xlsx",
        12: "DS_Satis_Telefon_Aralik_2023.xlsx",
      },
    },
  };

  //BUNLAR OK
  const gizliMusteriZiyaretSatisReports = {
    "Citroen": {
      2021: {
        "1. Dönem": "Citroen_Satis_Ziyaret_1_Donem_2021.xlsx",
        "2. Dönem": "Citroen_Satis_Ziyaret_2_Donem_2021.xlsx",
        "3. Dönem": "Citroen_Satis_Ziyaret_3_Donem_2021.xlsx",
        "4. Dönem": "Citroen_Satis_Ziyaret_4_Donem_2021.xlsx",
        "5. Dönem": "Citroen_Satis_Ziyaret_5_Donem_2021.xlsx",
        "6. Dönem": "Citroen_Satis_Ziyaret_6_Donem_2021.xlsx",
      },
      2022: {
        "1. Dönem": "Citroen_Satis_Ziyaret_1_Donem_2022.xlsx",
        "2. Dönem": "Citroen_Satis_Ziyaret_2_Donem_2022.xlsx",
        "3. Dönem": "Citroen_Satis_Ziyaret_3_Donem_2022.xlsx",
        "4. Dönem": "Citroen_Satis_Ziyaret_4_Donem_2022.xlsx",
        "5. Dönem": "Citroen_Satis_Ziyaret_5_Donem_2022.xlsx",
        "6. Dönem": "Citroen_Satis_Ziyaret_6_Donem_2022.xlsx",
      },
      2023: {
        "1. Dönem": "Citroen_Satis_Ziyaret_1_Donem_2023.xlsx",
        "2. Dönem": "Citroen_Satis_Ziyaret_2_Donem_2023.xlsx",
      },
    },
    "Peugeot": {
      2021: {
        "1. Dönem": "Peugeot_Satis_Ziyaret_1_Donem_2021.xlsx",
        "2. Dönem": "Peugeot_Satis_Ziyaret_2_Donem_2021.xlsx",
        "3. Dönem": "Peugeot_Satis_Ziyaret_3_Donem_2021.xlsx",
        "4. Dönem": "Peugeot_Satis_Ziyaret_4_Donem_2021.xlsx",
        "5. Dönem": "Peugeot_Satis_Ziyaret_5_Donem_2021.xlsx",
        "6. Dönem": "Peugeot_Satis_Ziyaret_6_Donem_2021.xlsx",
      },
      2022: {
        "1. Dönem": "Peugeot_Satis_Ziyaret_1_Donem_2022.xlsx",
        "2. Dönem": "Peugeot_Satis_Ziyaret_2_Donem_2022.xlsx",
        "3. Dönem": "Peugeot_Satis_Ziyaret_3_Donem_2022.xlsx",
        "4. Dönem": "Peugeot_Satis_Ziyaret_4_Donem_2022.xlsx",
        "5. Dönem": "Peugeot_Satis_Ziyaret_5_Donem_2022.xlsx",
        "6. Dönem": "Peugeot_Satis_Ziyaret_6_Donem_2022.xlsx",
      },
      2023: {
        "1. Dönem": "Peugeot_Satis_Ziyaret_1_Donem_2023.xlsx",
        "2. Dönem": "Peugeot_Satis_Ziyaret_2_Donem_2023.xlsx",
      },
    },
    "Opel": {
      2021: {
        "1. Dönem": "Opel_Satis_Ziyaret_1_Donem_2021.xlsx",
        "2. Dönem": "Opel_Satis_Ziyaret_2_Donem_2021.xlsx",
        "3. Dönem": "Opel_Satis_Ziyaret_3_Donem_2021.xlsx",
        "4. Dönem": "Opel_Satis_Ziyaret_4_Donem_2021.xlsx",
        "5. Dönem": "Opel_Satis_Ziyaret_5_Donem_2021.xlsx",
        "6. Dönem": "Opel_Satis_Ziyaret_6_Donem_2021.xlsx",
      },
      2022: {
        "1. Dönem": "Opel_Satis_Ziyaret_1_Donem_2022.xlsx",
        "2. Dönem": "Opel_Satis_Ziyaret_2_Donem_2022.xlsx",
        "3. Dönem": "Opel_Satis_Ziyaret_3_Donem_2022.xlsx",
        "4. Dönem": "Opel_Satis_Ziyaret_4_Donem_2022.xlsx",
        "5. Dönem": "Opel_Satis_Ziyaret_5_Donem_2022.xlsx",
        "6. Dönem": "Opel_Satis_Ziyaret_6_Donem_2022.xlsx",
      },
      2023: {
        "1. Dönem": "Opel_Satis_Ziyaret_1_Donem_2023.xlsx",
        "2. Dönem": "Opel_Satis_Ziyaret_2_Donem_2023.xlsx",
      },
    },
    "DS": {
      2021: {
        "Şubat": "DS_Satis_Ziyaret_Subat_2021.xlsx",
        "Mart": "DS_Satis_Ziyaret_Mart_2021.xlsx",
        "Nisan": "DS_Satis_Ziyaret_Nisan_2021.xlsx",
        "Mayıs": "DS_Satis_Ziyaret_Mayis_2021.xlsx",
        "Haziran": "DS_Satis_Ziyaret_Haziran_2021.xlsx",
        "Temmuz": "DS_Satis_Ziyaret_Temmuz_2021.xlsx",
        "Ağustos": "DS_Satis_Ziyaret_Agustos_2021.xlsx",
        "Eylül": "DS_Satis_Ziyaret_Eylul_2021.xlsx",
        "Ekim": "DS_Satis_Ziyaret_Ekim_2021.xlsx",
        "Kasım": "DS_Satis_Ziyaret_Kasim_2021.xlsx",
        "Aralık": "DS_Satis_Ziyaret_Aralik_2021.xlsx",
      },
      2022: {
        "Ocak": "DS_Satis_Ziyaret_Ocak_2022.xlsx",
        "Şubat": "DS_Satis_Ziyaret_Subat_2022.xlsx",
        "Mart": "DS_Satis_Ziyaret_Mart_2022.xlsx",
        "Nisan": "DS_Satis_Ziyaret_Nisan_2022.xlsx",
        "Mayıs": "DS_Satis_Ziyaret_Mayis_2022.xlsx",
        "Haziran": "DS_Satis_Ziyaret_Haziran_2022.xlsx",
        "Temmuz": "DS_Satis_Ziyaret_Temmuz_2022.xlsx",
        "Ağustos": "DS_Satis_Ziyaret_Agustos_2022.xlsx",
        "Eylül": "DS_Satis_Ziyaret_Eylul_2022.xlsx",
        "Ekim": "DS_Satis_Ziyaret_Ekim_2022.xlsx",
        "Kasım": "DS_Satis_Ziyaret_Kasim_2022.xlsx",
        "Aralık": "DS_Satis_Ziyaret_Aralik_2022.xlsx",
      },
      2023: {
        "Ocak": "DS_Satis_Ziyaret_Ocak_2023.xlsx",
        "Şubat": "DS_Satis_Ziyaret_Subat_2023.xlsx",
        "Mart": "DS_Satis_Ziyaret_Mart_2023.xlsx",
        "Nisan": "DS_Satis_Ziyaret_Nisan_2023.xlsx",
        "Mayıs": "DS_Satis_Ziyaret_Mayis_2023.xlsx",
        "Haziran": "DS_Satis_Ziyaret_Haziran_2023.xlsx",
        "Temmuz": "DS_Satis_Ziyaret_Temmuz_2023.xlsx",
        "Ağustos": "DS_Satis_Ziyaret_Agustos_2023.xlsx",
        "Eylül": "DS_Satis_Ziyaret_Eylul_2023.xlsx",
        "Ekim": "DS_Satis_Ziyaret_Ekim_2023.xlsx",
        "Kasım": "DS_Satis_Ziyaret_Kasim_2023.xlsx",
        "Aralık": "DS_Satis_Ziyaret_Aralik_2023.xlsx",
      },
    },
  };

  //BUNLAR OK
  const gizliMusteriZiyaretServisReports = {
    "Citroen": {
      2021: {
        "1. Dönem": "Citroen_Servis_Ziyaret_1_Donem_2021.xlsx",
        "2. Dönem": "Citroen_Servis_Ziyaret_2_Donem_2021.xlsx",
        "3. Dönem": "Citroen_Servis_Ziyaret_3_Donem_2021.xlsx",
        "4. Dönem": "Citroen_Servis_Ziyaret_4_Donem_2021.xlsx",
      },
      2022: {
        "1. Dönem": "Citroen_Servis_Ziyaret_1_Donem_2022.xlsx",
        "2. Dönem": "Citroen_Servis_Ziyaret_2_Donem_2022.xlsx",
        "3. Dönem": "Citroen_Servis_Ziyaret_3_Donem_2022.xlsx",
        "4. Dönem": "Citroen_Servis_Ziyaret_4_Donem_2022.xlsx",
      },
      2023: {
        "1. Dönem": "Citroen_Servis_Ziyaret_1_Donem_2023.xlsx",
        "2. Dönem": "Citroen_Servis_Ziyaret_2_Donem_2023.xlsx",

      },
    },
    "Peugeot": {
      2021: {
        "1. Dönem": "Peugeot_Servis_Ziyaret_1_Donem_2021.xlsx",
        "2. Dönem": "Peugeot_Servis_Ziyaret_2_Donem_2021.xlsx",
        "3. Dönem": "Peugeot_Servis_Ziyaret_3_Donem_2021.xlsx",
        "4. Dönem": "Peugeot_Servis_Ziyaret_4_Donem_2021.xlsx",
      },
      2022: {
        "1. Dönem": "Peugeot_Servis_Ziyaret_1_Donem_2022.xlsx",
        "2. Dönem": "Peugeot_Servis_Ziyaret_2_Donem_2022.xlsx",
        "3. Dönem": "Peugeot_Servis_Ziyaret_3_Donem_2022.xlsx",
        "4. Dönem": "Peugeot_Servis_Ziyaret_4_Donem_2022.xlsx",
      },
      2023: {
        "1. Dönem": "Peugeot_Servis_Ziyaret_1_Donem_2023.xlsx",
        "2. Dönem": "Peugeot_Servis_Ziyaret_2_Donem_2023.xlsx",

      },
    },
    "Opel": {
      2021: {
        "1. Dönem": "Opel_Servis_Ziyaret_1_Donem_2021.xlsx",
        "2. Dönem": "Opel_Servis_Ziyaret_2_Donem_2021.xlsx",
        "3. Dönem": "Opel_Servis_Ziyaret_3_Donem_2021.xlsx",
        "4. Dönem": "Opel_Servis_Ziyaret_4_Donem_2021.xlsx",
      },
      2022: {
        "1. Dönem": "Opel_Servis_Ziyaret_1_Donem_2022.xlsx",
        "2. Dönem": "Opel_Servis_Ziyaret_2_Donem_2022.xlsx",
        "3. Dönem": "Opel_Servis_Ziyaret_3_Donem_2022.xlsx",
        "4. Dönem": "Opel_Servis_Ziyaret_4_Donem_2022.xlsx",
      },
      2023: {
        "1. Dönem": "Opel_Servis_Ziyaret_1_Donem_2023.xlsx",
        "2. Dönem": "Opel_Servis_Ziyaret_2_Donem_2023.xlsx",

      },
    },
  };

  //BUNLAR OK
  const lcvSatisReports = {
    "Citroen": {
      2022: {
        "Şubat": ["LCV_Satis_Citroen_Subat_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Subat_2022_Tum_Anketler.xlsx"],
        "Mart": ["LCV_Satis_Citroen_Mart_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Mart_2022_Tum_Anketler.xlsx"],
        "Nisan": ["LCV_Satis_Citroen_Nisan_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Nisan_2022_Tum_Anketler.xlsx"],
        "Mayıs": ["LCV_Satis_Citroen_Mayis_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Mayis_2022_Tum_Anketler.xlsx"],
        "Haziran": ["LCV_Satis_Citroen_Haziran_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Haziran_2022_Tum_Anketler.xlsx"],
        "Temmuz": ["LCV_Satis_Citroen_Temmuz_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Temmuz_2022_Tum_Anketler.xlsx"],
        "Ağustos": ["LCV_Satis_Citroen_Agustos_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Agustos_2022_Tum_Anketler.xlsx"],
        "Eylül": ["LCV_Satis_Citroen_Eylul_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Eylul_2022_Tum_Anketler.xlsx"],
        "Ekim": ["LCV_Satis_Citroen_Ekim_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Ekim_2022_Tum_Anketler.xlsx"],
        "Kasım": ["LCV_Satis_Citroen_Kasim_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Kasim_2022_Tum_Anketler.xlsx"],
        "Aralık": ["LCV_Satis_Citroen_Aralik_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Aralik_2022_Tum_Anketler.xlsx"],
      },
      2023: {
        "Ocak": ["LCV_Satis_Citroen_Ocak_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Ocak_2023_Tum_Anketler.xlsx"],
        "Şubat": ["LCV_Satis_Citroen_Subat_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Subat_2023_Tum_Anketler.xlsx"],
        "Mart": ["LCV_Satis_Citroen_Mart_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Mart_2023_Tum_Anketler.xlsx"],
        "Nisan": ["LCV_Satis_Citroen_Nisan_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Nisan_2023_Tum_Anketler.xlsx"],
        "Mayıs": ["LCV_Satis_Citroen_Mayis_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Mayis_2023_Tum_Anketler.xlsx"],
        "Haziran": ["LCV_Satis_Citroen_Haziran_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Haziran_2023_Tum_Anketler.xlsx"],
        "Temmuz": ["LCV_Satis_Citroen_Temmuz_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Temmuz_2023_Tum_Anketler.xlsx"],
        "Ağustos": ["LCV_Satis_Citroen_Agustos_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Agustos_2023_Tum_Anketler.xlsx"],
        "Eylül": ["LCV_Satis_Citroen_Eylul_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Eylul_2023_Tum_Anketler.xlsx"],
        "Ekim": ["LCV_Satis_Citroen_Ekim_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Ekim_2023_Tum_Anketler.xlsx"],
        "Kasım": ["LCV_Satis_Citroen_Kasim_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Kasim_2023_Tum_Anketler.xlsx"],
        "Aralık": ["LCV_Satis_Citroen_Aralik_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Citroen_Aralik_2023_Tum_Anketler.xlsx"],

      },
    },
    "Peugeot": {
      2022: {
        "Şubat": ["LCV_Satis_Peugeot_Subat_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Subat_2022_Tum_Anketler.xlsx"],
        "Mart": ["LCV_Satis_Peugeot_Mart_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Mart_2022_Tum_Anketler.xlsx"],
        "Nisan": ["LCV_Satis_Peugeot_Nisan_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Nisan_2022_Tum_Anketler.xlsx"],
        "Mayıs": ["LCV_Satis_Peugeot_Mayis_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Mayis_2022_Tum_Anketler.xlsx"],
        "Haziran": ["LCV_Satis_Peugeot_Haziran_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Haziran_2022_Tum_Anketler.xlsx"],
        "Temmuz": ["LCV_Satis_Peugeot_Temmuz_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Temmuz_2022_Tum_Anketler.xlsx"],
        "Ağustos": ["LCV_Satis_Peugeot_Agustos_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Agustos_2022_Tum_Anketler.xlsx"],
        "Eylül": ["LCV_Satis_Peugeot_Eylul_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Eylul_2022_Tum_Anketler.xlsx"],
        "Ekim": ["LCV_Satis_Peugeot_Ekim_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Ekim_2022_Tum_Anketler.xlsx"],
        "Kasım": ["LCV_Satis_Peugeot_Kasim_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Kasim_2022_Tum_Anketler.xlsx"],
        "Aralık": ["LCV_Satis_Peugeot_Aralik_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Aralik_2022_Tum_Anketler.xlsx"],
      },
      2023: {
        "Ocak": ["LCV_Satis_Peugeot_Ocak_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Ocak_2023_Tum_Anketler.xlsx"],
        "Şubat": ["LCV_Satis_Peugeot_Subat_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Subat_2023_Tum_Anketler.xlsx"],
        "Mart": ["LCV_Satis_Peugeot_Mart_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Mart_2023_Tum_Anketler.xlsx"],
        "Nisan": ["LCV_Satis_Peugeot_Nisan_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Nisan_2023_Tum_Anketler.xlsx"],
        "Mayıs": ["LCV_Satis_Peugeot_Mayis_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Mayis_2023_Tum_Anketler.xlsx"],
        "Haziran": ["LCV_Satis_Peugeot_Haziran_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Haziran_2023_Tum_Anketler.xlsx"],
        "Temmuz": ["LCV_Satis_Peugeot_Temmuz_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Temmuz_2023_Tum_Anketler.xlsx"],
        "Ağustos": ["LCV_Satis_Peugeot_Agustos_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Agustos_2023_Tum_Anketler.xlsx"],
        "Eylül": ["LCV_Satis_Peugeot_Eylul_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Eylul_2023_Tum_Anketler.xlsx"],
        "Ekim": ["LCV_Satis_Peugeot_Ekim_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Ekim_2023_Tum_Anketler.xlsx"],
        "Kasım": ["LCV_Satis_Peugeot_Kasim_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Kasim_2023_Tum_Anketler.xlsx"],
        "Aralık": ["LCV_Satis_Peugeot_Aralik_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Peugeot_Aralik_2023_Tum_Anketler.xlsx"],
      },
    },
    "Opel": {
      2022: {
        "Şubat": ["LCV_Satis_Opel_Subat_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Subat_2022_Tum_Anketler.xlsx"],
        "Mart": ["LCV_Satis_Opel_Mart_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Mart_2022_Tum_Anketler.xlsx"],
        "Nisan": ["LCV_Satis_Opel_Nisan_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Nisan_2022_Tum_Anketler.xlsx"],
        "Mayıs": ["LCV_Satis_Opel_Mayis_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Mayis_2022_Tum_Anketler.xlsx"],
        "Haziran": ["LCV_Satis_Opel_Haziran_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Haziran_2022_Tum_Anketler.xlsx"],
        "Temmuz": ["LCV_Satis_Opel_Temmuz_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Temmuz_2022_Tum_Anketler.xlsx"],
        "Ağustos": ["LCV_Satis_Opel_Agustos_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Agustos_2022_Tum_Anketler.xlsx"],
        "Eylül": ["LCV_Satis_Opel_Eylul_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Eylul_2022_Tum_Anketler.xlsx"],
        "Ekim": ["LCV_Satis_Opel_Ekim_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Ekim_2022_Tum_Anketler.xlsx"],
        "Kasım": ["LCV_Satis_Opel_Kasim_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Kasim_2022_Tum_Anketler.xlsx"],
        "Aralık": ["LCV_Satis_Opel_Aralik_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Aralik_2022_Tum_Anketler.xlsx"],
      },
      2023: {
        "Ocak": ["LCV_Satis_Opel_Ocak_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Ocak_2023_Tum_Anketler.xlsx"],
        "Şubat": ["LCV_Satis_Opel_Subat_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Subat_2023_Tum_Anketler.xlsx"],
        "Mart": ["LCV_Satis_Opel_Mart_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Mart_2023_Tum_Anketler.xlsx"],
        "Nisan": ["LCV_Satis_Opel_Nisan_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Nisan_2023_Tum_Anketler.xlsx"],
        "Mayıs": ["LCV_Satis_Opel_Mayis_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Mayis_2023_Tum_Anketler.xlsx"],
        "Haziran": ["LCV_Satis_Opel_Haziran_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Haziran_2023_Tum_Anketler.xlsx"],
        "Temmuz": ["LCV_Satis_Opel_Temmuz_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Temmuz_2023_Tum_Anketler.xlsx"],
        "Ağustos": ["LCV_Satis_Opel_Agustos_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Agustos_2023_Tum_Anketler.xlsx"],
        "Eylül": ["LCV_Satis_Opel_Eylul_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Eylul_2023_Tum_Anketler.xlsx"],
        "Ekim": ["LCV_Satis_Opel_Ekim_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Ekim_2023_Tum_Anketler.xlsx"],
        "Kasım": ["LCV_Satis_Opel_Kasim_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Kasim_2023_Tum_Anketler.xlsx"],
        "Aralık": ["LCV_Satis_Opel_Aralik_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Satis_Opel_Aralik_2023_Tum_Anketler.xlsx"],

      },
    },

  };

  //BUNLAR OK
  const lcvServisReports = {
    "Citroen": {
      2022: {
        "Mart": ["LCV_Servis_Citroen_Mart_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Mart_2022_Tum_Anketler.xlsx"],
        "Nisan": ["LCV_Servis_Citroen_Nisan_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Nisan_2022_Tum_Anketler.xlsx"],
        "Mayıs": ["LCV_Servis_Citroen_Mayis_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Mayis_2022_Tum_Anketler.xlsx"],
        "Haziran": ["LCV_Servis_Citroen_Haziran_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Haziran_2022_Tum_Anketler.xlsx"],
        "Temmuz": ["LCV_Servis_Citroen_Temmuz_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Temmuz_2022_Tum_Anketler.xlsx"],
        "Ağustos": ["LCV_Servis_Citroen_Agustos_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Agustos_2022_Tum_Anketler.xlsx"],
        "Eylül": ["LCV_Servis_Citroen_Eylul_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Eylul_2022_Tum_Anketler.xlsx"],
        "Ekim": ["LCV_Servis_Citroen_Ekim_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Ekim_2022_Tum_Anketler.xlsx"],
        "Kasım": ["LCV_Servis_Citroen_Kasim_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Kasim_2022_Tum_Anketler.xlsx"],
        "Aralık": ["LCV_Servis_Citroen_Aralik_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Aralik_2022_Tum_Anketler.xlsx"],
      },
      2023: {
        "Ocak": ["LCV_Servis_Citroen_Ocak_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Ocak_2023_Tum_Anketler.xlsx"],
        "Şubat": ["LCV_Servis_Citroen_Subat_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Subat_2023_Tum_Anketler.xlsx"],
        "Mart": ["LCV_Servis_Citroen_Mart_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Mart_2023_Tum_Anketler.xlsx"],
        "Nisan": ["LCV_Servis_Citroen_Nisan_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Nisan_2023_Tum_Anketler.xlsx"],
        "Mayıs": ["LCV_Servis_Citroen_Mayis_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Mayis_2023_Tum_Anketler.xlsx"],
        "Haziran": ["LCV_Servis_Citroen_Haziran_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Haziran_2023_Tum_Anketler.xlsx"],
        "Temmuz": ["LCV_Servis_Citroen_Temmuz_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Temmuz_2023_Tum_Anketler.xlsx"],
        "Ağustos": ["LCV_Servis_Citroen_Agustos_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Agustos_2023_Tum_Anketler.xlsx"],
        "Eylül": ["LCV_Servis_Citroen_Eylul_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Eylul_2023_Tum_Anketler.xlsx"],
        "Ekim": ["LCV_Servis_Citroen_Ekim_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Ekim_2023_Tum_Anketler.xlsx"],
        "Kasım": ["LCV_Servis_Citroen_Kasim_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Kasim_2023_Tum_Anketler.xlsx"],
        "Aralık": ["LCV_Servis_Citroen_Aralik_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Citroen_Aralik_2023_Tum_Anketler.xlsx"],

      },
    },
    "Peugeot": {
      2022: {
        "Mart": ["LCV_Servis_Peugeot_Mart_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Mart_2022_Tum_Anketler.xlsx"],
        "Nisan": ["LCV_Servis_Peugeot_Nisan_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Nisan_2022_Tum_Anketler.xlsx"],
        "Mayıs": ["LCV_Servis_Peugeot_Mayis_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Mayis_2022_Tum_Anketler.xlsx"],
        "Haziran": ["LCV_Servis_Peugeot_Haziran_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Haziran_2022_Tum_Anketler.xlsx"],
        "Temmuz": ["LCV_Servis_Peugeot_Temmuz_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Temmuz_2022_Tum_Anketler.xlsx"],
        "Ağustos": ["LCV_Servis_Peugeot_Agustos_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Agustos_2022_Tum_Anketler.xlsx"],
        "Eylül": ["LCV_Servis_Peugeot_Eylul_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Eylul_2022_Tum_Anketler.xlsx"],
        "Ekim": ["LCV_Servis_Peugeot_Ekim_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Ekim_2022_Tum_Anketler.xlsx"],
        "Kasım": ["LCV_Servis_Peugeot_Kasim_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Kasim_2022_Tum_Anketler.xlsx"],
        "Aralık": ["LCV_Servis_Peugeot_Aralik_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Aralik_2022_Tum_Anketler.xlsx"],
      },
      2023: {
        "Ocak": ["LCV_Servis_Peugeot_Ocak_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Ocak_2023_Tum_Anketler.xlsx"],
        "Şubat": ["LCV_Servis_Peugeot_Subat_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Subat_2023_Tum_Anketler.xlsx"],
        "Mart": ["LCV_Servis_Peugeot_Mart_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Mart_2023_Tum_Anketler.xlsx"],
        "Nisan": ["LCV_Servis_Peugeot_Nisan_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Nisan_2023_Tum_Anketler.xlsx"],
        "Mayıs": ["LCV_Servis_Peugeot_Mayis_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Mayis_2023_Tum_Anketler.xlsx"],
        "Haziran": ["LCV_Servis_Peugeot_Haziran_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Haziran_2023_Tum_Anketler.xlsx"],
        "Temmuz": ["LCV_Servis_Peugeot_Temmuz_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Temmuz_2023_Tum_Anketler.xlsx"],
        "Ağustos": ["LCV_Servis_Peugeot_Agustos_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Agustos_2023_Tum_Anketler.xlsx"],
        "Eylül": ["LCV_Servis_Peugeot_Eylul_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Eylul_2023_Tum_Anketler.xlsx"],
        "Ekim": ["LCV_Servis_Peugeot_Ekim_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Ekim_2023_Tum_Anketler.xlsx"],
        "Kasım": ["LCV_Servis_Peugeot_Kasim_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Kasim_2023_Tum_Anketler.xlsx"],
        "Aralık": ["LCV_Servis_Peugeot_Aralik_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Peugeot_Aralik_2023_Tum_Anketler.xlsx"],
      },
    },
    "Opel": {
      2022: {
        "Mart": ["LCV_Servis_Opel_Mart_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Mart_2022_Tum_Anketler.xlsx"],
        "Nisan": ["LCV_Servis_Opel_Nisan_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Nisan_2022_Tum_Anketler.xlsx"],
        "Mayıs": ["LCV_Servis_Opel_Mayis_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Mayis_2022_Tum_Anketler.xlsx"],
        "Haziran": ["LCV_Servis_Opel_Haziran_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Haziran_2022_Tum_Anketler.xlsx"],
        "Temmuz": ["LCV_Servis_Opel_Temmuz_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Temmuz_2022_Tum_Anketler.xlsx"],
        "Ağustos": ["LCV_Servis_Opel_Agustos_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Agustos_2022_Tum_Anketler.xlsx"],
        "Eylül": ["LCV_Servis_Opel_Eylul_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Eylul_2022_Tum_Anketler.xlsx"],
        "Ekim": ["LCV_Servis_Opel_Ekim_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Ekim_2022_Tum_Anketler.xlsx"],
        "Kasım": ["LCV_Servis_Opel_Kasim_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Kasim_2022_Tum_Anketler.xlsx"],
        "Aralık": ["LCV_Servis_Opel_Aralik_2022_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Aralik_2022_Tum_Anketler.xlsx"],
      },
      2023: {
        "Ocak": ["LCV_Servis_Opel_Ocak_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Ocak_2023_Tum_Anketler.xlsx"],
        "Şubat": ["LCV_Servis_Opel_Subat_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Subat_2023_Tum_Anketler.xlsx"],
        "Mart": ["LCV_Servis_Opel_Mart_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Mart_2023_Tum_Anketler.xlsx"],
        "Nisan": ["LCV_Servis_Opel_Nisan_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Nisan_2023_Tum_Anketler.xlsx"],
        "Mayıs": ["LCV_Servis_Opel_Mayis_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Mayis_2023_Tum_Anketler.xlsx"],
        "Haziran": ["LCV_Servis_Opel_Haziran_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Haziran_2023_Tum_Anketler.xlsx"],
        "Temmuz": ["LCV_Servis_Opel_Temmuz_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Temmuz_2023_Tum_Anketler.xlsx"],
        "Ağustos": ["LCV_Servis_Opel_Agustos_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Agustos_2023_Tum_Anketler.xlsx"],
        "Eylül": ["LCV_Servis_Opel_Eylul_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Eylul_2023_Tum_Anketler.xlsx"],
        "Ekim": ["LCV_Servis_Opel_Ekim_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Ekim_2023_Tum_Anketler.xlsx"],
        "Kasım": ["LCV_Servis_Opel_Kasim_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Kasim_2023_Tum_Anketler.xlsx"],
        "Aralık": ["LCV_Servis_Opel_Aralik_2023_Sirket_Sahibi_Anketleri.xlsx", "LCV_Servis_Opel_Aralik_2023_Tum_Anketler.xlsx"],

      },
    },

  };


  const reddedenlerReports = {
    "Citroen": {
      2022: {
        "1. Dönem": ["Reddedenler_Citroen_1_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Citroen_1_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Citroen_1_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
        "2. Dönem": ["Reddedenler_Citroen_2_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Citroen_2_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Citroen_2_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
        "3. Dönem": ["Reddedenler_Citroen_3_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Citroen_3_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Citroen_3_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
        "4. Dönem": ["Reddedenler_Citroen_4_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Citroen_4_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Citroen_4_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
      },
      2023: {
        "1. Dönem": ["Reddedenler_Citroen_1_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Citroen_1_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Citroen_1_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
        "2. Dönem": ["Reddedenler_Citroen_2_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Citroen_2_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Citroen_2_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
        "3. Dönem": ["Reddedenler_Citroen_3_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Citroen_3_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Citroen_3_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
        "4. Dönem": ["Reddedenler_Citroen_4_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Citroen_4_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Citroen_4_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
      }
    },
    "Peugeot": {
      2021: {
        2022: {
          "1. Dönem": ["Reddedenler_Peugeot_1_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
            "Reddedenler_Peugeot_1_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
            "Reddedenler_Peugeot_1_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
          "2. Dönem": ["Reddedenler_Peugeot_2_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
            "Reddedenler_Peugeot_2_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
            "Reddedenler_Peugeot_2_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
          "3. Dönem": ["Reddedenler_Peugeot_3_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
            "Reddedenler_Peugeot_3_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
            "Reddedenler_Peugeot_3_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
          "4. Dönem": ["Reddedenler_Peugeot_4_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
            "Reddedenler_Peugeot_4_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
            "Reddedenler_Peugeot_4_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
        },
        2023: {
          "1. Dönem": ["Reddedenler_Peugeot_1_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
            "Reddedenler_Peugeot_1_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
            "Reddedenler_Peugeot_1_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
          "2. Dönem": ["Reddedenler_Peugeot_2_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
            "Reddedenler_Peugeot_2_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
            "Reddedenler_Peugeot_2_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
          "3. Dönem": ["Reddedenler_Peugeot_3_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
            "Reddedenler_Peugeot_3_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
            "Reddedenler_Peugeot_3_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
          "4. Dönem": ["Reddedenler_Peugeot_4_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
            "Reddedenler_Peugeot_4_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
            "Reddedenler_Peugeot_4_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
        }
      },
    },
    "Opel": {
      2022: {
        "1. Dönem": ["Reddedenler_Opel_1_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Opel_1_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Opel_1_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
        "2. Dönem": ["Reddedenler_Opel_2_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Opel_2_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Opel_2_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
        "3. Dönem": ["Reddedenler_Opel_3_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Opel_3_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Opel_3_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
        "4. Dönem": ["Reddedenler_Opel_4_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Opel_4_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Opel_4_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
      },
      2023: {
        "1. Dönem": ["Reddedenler_Opel_1_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Opel_1_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Opel_1_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
        "2. Dönem": ["Reddedenler_Opel_2_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Opel_2_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Opel_2_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
        "3. Dönem": ["Reddedenler_Opel_3_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Opel_3_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Opel_3_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
        "4. Dönem": ["Reddedenler_Opel_4_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_Opel_4_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_Opel_4_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
      }
    },
    "DS": {
      2022: {
        "1. Dönem": ["Reddedenler_DS_1_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_DS_1_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_DS_1_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
        "2. Dönem": ["Reddedenler_DS_2_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_DS_2_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_DS_2_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
        "3. Dönem": ["Reddedenler_DS_3_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_DS_3_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_DS_3_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
        "4. Dönem": ["Reddedenler_DS_4_Donem_Aylik_Donemlik_2022_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_DS_4_Donem_Aylik_Donemlik_2022_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_DS_4_Donem_Aylik_Donemlik_2022_Tum_Anketler.xlsx"],
      },
      2023: {
        "1. Dönem": ["Reddedenler_DS_1_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_DS_1_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_DS_1_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
        "2. Dönem": ["Reddedenler_DS_2_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_DS_2_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_DS_2_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
        "3. Dönem": ["Reddedenler_DS_3_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_DS_3_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_DS_3_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
        "4. Dönem": ["Reddedenler_DS_4_Donem_Aylik_Donemlik_2023_Baska_Marka_Arac_Satin_Alanlar.xlsx",
          "Reddedenler_DS_4_Donem_Aylik_Donemlik_2023_Hic_Arac_Satin_Almayanlar.xlsx",
          "Reddedenler_DS_4_Donem_Aylik_Donemlik_2023_Tum_Anketler.xlsx"],
      }

    },
  };


  const otherReports = {

  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    setFilters((prev) => ({ ...prev, [name]: value }));

    if (name === 'project') {

      if (value === 'Eurorepar') {
        // Eurorepar seçildiğinde rapor dışındaki filtreleri sıfırla ve sadece rapor aktif olsun
        setFilters({ project: value, year: '', month: '', report: value });
      } 
      else if (value === 'Gizli Müşteri Telefon') {
        // Gizli Müşteri Telefon seçildiğinde sadece marka aktif olsun
        setFilters({ project: value, brand: '', year: '', month: '', report: '' });
      }
      else if (value === 'Gizli Müşteri Ziyaret - Satış') {
        // Gizli Müşteri Ziyaret - Satış seçildiğinde sadece marka aktif olsun
        setFilters({ project: value, brand: '', year: '', month: '', report: '' });
      }
      else if (value === 'Gizli Müşteri Ziyaret - Servis') {
        // Gizli Müşteri Ziyaret - Servis seçildiğinde sadece marka aktif olsun
        setFilters({ project: value, brand: '', year: '', month: '', report: '' });
      }
      else if (value === 'LCV - Satış') {
        // LCV - Satış seçildiğinde sadece marka aktif olsun
        setFilters({ project: value, brand: '', year: '', month: '', report: '' });
      }
      else if (value === 'LCV - Servis') {
        // LCV - Servis seçildiğinde sadece marka aktif olsun
        setFilters({ project: value, brand: '', year: '', month: '', report: '' });
      }
      else if (value === 'Reddedenler') {
        // LCV - Servis seçildiğinde sadece marka aktif olsun
        setFilters({ project: value, brand: '', year: '', month: '', report: '' });
      }
      else {
        // Diğer projeler için genel sıfırlama
        setFilters((prev) => ({ ...prev, brand: '', year: '', month: '', report: '' }));
      }
    }

    if (name === 'brand') {
      if (
        filters.project === 'Gizli Müşteri Telefon' ||
        filters.project === 'Gizli Müşteri Ziyaret - Satış' ||
        filters.project === 'Gizli Müşteri Ziyaret - Servis' ||
        filters.project === 'LCV - Satış' ||
        filters.project === 'LCV - Servis' || 
        filters.project === 'Reddedenler' ) {
        setFilters((prev) => ({ ...prev, year: '', month: '' }));
      }
    }

    if (name === 'year') {
      // Yıl seçildiğinde ay sıfırlanır (genel mantık)
      setFilters((prev) => ({ ...prev, month: '' }));
    }
  };




  const renderMonths = () => {
    if (filters.project === 'Gizli Müşteri Telefon' && filters.brand && filters.year) {
      // Yıl seçildiğinde ay dropdown'unu doldur
      return Object.keys(gizliMusteriTelefonReports[filters.brand]?.[filters.year] || {}).map((month) => (
        <option key={month} value={month}>
          {new Date(filters.year, month - 1).toLocaleString('tr-TR', { month: 'long' })}
        </option>
      ));
    }
    if (filters.project === 'Gizli Müşteri Ziyaret - Satış' && filters.brand && filters.year) {
      // Burada "1. Dönem", "2. Dönem" gibi özel dönem adlarını döndür
      return Object.keys(gizliMusteriZiyaretSatisReports[filters.brand]?.[filters.year] || {}).map((period) => (
        <option key={period} value={period}>
          {period}
        </option>
      ));
    }

    if (filters.project === 'Gizli Müşteri Ziyaret - Servis' && filters.brand && filters.year) {
      // Yıl seçildiğinde ay dropdown'unu doldur
      return Object.keys(gizliMusteriZiyaretServisReports[filters.brand]?.[filters.year] || {}).map((period) => (
        <option key={period} value={period}>
          {period}
        </option>
      ));
    }
    if (filters.project === 'LCV - Satış' && filters.brand && filters.year) {
      // Yıl seçildiğinde ay dropdown'unu doldur
      return Object.keys(lcvSatisReports[filters.brand]?.[filters.year] || {}).map((period) => (
        <option key={period} value={period}>
          {period}
        </option>
      ));
    }
    if (filters.project === 'LCV - Servis' && filters.brand && filters.year) {
      // Yıl seçildiğinde ay dropdown'unu doldur
      return Object.keys(lcvServisReports[filters.brand]?.[filters.year] || {}).map((period) => (
        <option key={period} value={period}>
          {period}
        </option>
      ));
    }
    if (filters.project === 'Reddedenler' && filters.brand && filters.year) {
      // Yıl seçildiğinde ay dropdown'unu doldur
      return Object.keys(reddedenlerReports[filters.brand]?.[filters.year] || {}).map((period) => (
        <option key={period} value={period}>
          {period}
        </option>
      ));
    }

    if (filters.year === '2021') {
      return [8, 9, 10, 11, 12].map((month) => (
        <option key={month} value={month}>
          {new Date(2021, month - 1).toLocaleString('tr-TR', { month: 'long' })}
        </option>
      ));
    }
    return Array.from({ length: 12 }, (_, i) => (
      <option key={i + 1} value={i + 1}>
        {new Date(2021, i).toLocaleString('tr-TR', { month: 'long' })}
      </option>
    ));
  };

  const renderReports = () => {
    console.log("Selected Filters:", filters);

// Eurorepar için raporları döndür
// Eurorepar için raporları döndür
if (filters.project === 'Eurorepar' && filters.year) {
  const yearReports = euroreparReports[filters.year] || {};

  // Ay filtresi varsa
  if (filters.month) {
    const periodReports = yearReports[filters.month];

    if (Array.isArray(periodReports)) {
      return periodReports.map((fileName, index) => (
        <li key={index}>
          <a
            href={`/data/EUROREPAR/${fileName}`}
            download={fileName}
            className="report-link"
          >
            {fileName}
          </a>
        </li>
      ));
    }

    if (typeof periodReports === 'string') {
      return (
        <li key={filters.month}>
          <a
            href={`/data/EUROREPAR/${periodReports}`}
            download={periodReports}
            className="report-link"
          >
            {periodReports}
          </a>
        </li>
      );
    }

    // Seçilen ayda rapor bulunamazsa
    return <p>Seçilen aya ait rapor bulunamadı.</p>;
  }

  // Ay filtresi yoksa yıl içindeki tüm raporları göster
  return Object.entries(yearReports).flatMap(([month, report]) => {
    if (Array.isArray(report)) {
      return report.map((fileName, index) => (
        <li key={`${month}-${index}`}>
          <a
            href={`/data/EUROREPAR/${fileName}`}
            download={fileName}
            className="report-link"
          >
            {fileName}
          </a>
        </li>
      ));
    }

    return (
      <li key={month}>
        <a
          href={`/data/EUROREPAR/${report}`}
          download={report}
          className="report-link"
        >
          {report}
        </a>
      </li>
    );
  });
}



    // Gizli Müşteri Telefon için raporları döndür
    if (filters.project === 'Gizli Müşteri Telefon' && filters.brand && filters.year) {
      const yearReports = gizliMusteriTelefonReports[filters.brand]?.[filters.year] || {};
      if (filters.month) {
        const monthReport = yearReports[parseInt(filters.month)];
        return monthReport ? (
          <li key={filters.month}>
            <a
              href={`/data/GIZLI_MUSTERI_TELEFON/${monthReport}`}
              download={monthReport}
              className="report-link"
            >
              {monthReport}
            </a>
          </li>
        ) : (
          <p>Seçilen aya ait rapor bulunamadı.</p>
        );
      }
      return Object.entries(yearReports).map(([month, fileName]) => (
        <li key={month}>
          <a
            href={`/data/GIZLI_MUSTERI_TELEFON/${fileName}`}
            download={fileName}
            className="report-link"
          >
            {fileName}
          </a>
        </li>
      ));
    }

    // Gizli Müşteri Ziyaret - Satış için raporları döndür
    if (filters.project === 'Gizli Müşteri Ziyaret - Satış' && filters.brand && filters.year) {
      const yearReports = gizliMusteriZiyaretSatisReports[filters.brand]?.[filters.year] || {};
      if (filters.month) {
        const periodReport = yearReports[filters.month];
        return periodReport ? (
          <li key={filters.month}>
            <a
              href={`/data/GIZLI_MUSTERI_ZIYARET_SATIS/${periodReport}`}
              download={periodReport}
              className="report-link"
            >
              {periodReport}
            </a>
          </li>
        ) : (
          <p>Seçilen döneme ait rapor bulunamadı.</p>
        );
      }
      return Object.entries(yearReports).map(([period, fileName]) => (
        <li key={period}>
          <a
            href={`/data/GIZLI_MUSTERI_ZIYARET_SATIS/${fileName}`}
            download={fileName}
            className="report-link"
          >
            {fileName}
          </a>
        </li>
      ));
    }

    // Gizli Müşteri Ziyaret - Servis için raporları döndür
    if (filters.project === 'Gizli Müşteri Ziyaret - Servis' && filters.brand && filters.year) {
      const yearReports = gizliMusteriZiyaretServisReports[filters.brand]?.[filters.year] || {};
      if (filters.month) {
        const periodReport = yearReports[filters.month];
        return periodReport ? (
          <li key={filters.month}>
            <a
              href={`/data/GIZLI_MUSTERI_ZIYARET_SERVIS/${periodReport}`}
              download={periodReport}
              className="report-link"
            >
              {periodReport}
            </a>
          </li>
        ) : (
          <p>Seçilen aya ait rapor bulunamadı.</p>
        );
      }
      return Object.entries(yearReports).map(([period, fileName]) => (
        <li key={period}>
          <a
            href={`/data/GIZLI_MUSTERI_ZIYARET_SERVIS/${fileName}`}
            download={fileName}
            className="report-link"
          >
            {fileName}
          </a>
        </li>
      ));
    }

    // LCV - Satış için raporları döndür
    if (filters.project === 'LCV - Satış' && filters.brand && filters.year) {
      const yearReports = lcvSatisReports[filters.brand]?.[filters.year] || {};
      if (filters.month) {
        const periodReports = yearReports[filters.month];
        if (Array.isArray(periodReports)) {
          return periodReports.map((fileName, index) => (
            <li key={index}>
              <a
                href={`/data/LCV_SATIS/${fileName}`}
                download={fileName}
                className="report-link"
              >
                {fileName}
              </a>
            </li>
          ));
        }
        if (typeof periodReports === 'string') {
          return (
            <li key={filters.month}>
              <a
                href={`/data/LCV_SATIS/${periodReports}`}
                download={periodReports}
                className="report-link"
              >
                {periodReports}
              </a>
            </li>
          );
        }
        return <p>Seçilen aya ait rapor bulunamadı.</p>;
      }
      return Object.entries(yearReports).flatMap(([period, report]) => {
        if (Array.isArray(report)) {
          return report.map((fileName, index) => (
            <li key={`${period}-${index}`}>
              <a
                href={`/data/LCV_SATIS/${fileName}`}
                download={fileName}
                className="report-link"
              >
                {fileName}
              </a>
            </li>
          ));
        }
        return (
          <li key={period}>
            <a
              href={`/data/LCV_SATIS/${report}`}
              download={report}
              className="report-link"
            >
              {report}
            </a>
          </li>
        );
      });
    }

    // LCV - Servis için raporları döndür
    if (filters.project === 'LCV - Servis' && filters.brand && filters.year) {
      const yearReports = lcvServisReports[filters.brand]?.[filters.year] || {};
      if (filters.month) {
        const periodReports = yearReports[filters.month];
        if (Array.isArray(periodReports)) {
          return periodReports.map((fileName, index) => (
            <li key={index}>
              <a
                href={`/data/LCV_SERVIS/${fileName}`}
                download={fileName}
                className="report-link"
              >
                {fileName}
              </a>
            </li>
          ));
        }
        if (typeof periodReports === 'string') {
          return (
            <li key={filters.month}>
              <a
                href={`/data/LCV_SERVIS/${periodReports}`}
                download={periodReports}
                className="report-link"
              >
                {periodReports}
              </a>
            </li>
          );
        }
        return <p>Seçilen aya ait rapor bulunamadı.</p>;
      }
      return Object.entries(yearReports).flatMap(([period, report]) => {
        if (Array.isArray(report)) {
          return report.map((fileName, index) => (
            <li key={`${period}-${index}`}>
              <a
                href={`/data/LCV_SERVIS/${fileName}`}
                download={fileName}
                className="report-link"
              >
                {fileName}
              </a>
            </li>
          ));
        }
        return (
          <li key={period}>
            <a
              href={`/data/LCV_SERVIS/${report}`}
              download={report}
              className="report-link"
            >
              {report}
            </a>
          </li>
        );
      });
    }

    // Reddedenler için raporları döndür
    if (filters.project === 'Reddedenler' && filters.brand && filters.year) {
      const yearReports = reddedenlerReports[filters.brand]?.[filters.year] || {};
      if (filters.month) {
        const periodReports = yearReports[filters.month];
        if (Array.isArray(periodReports)) {
          return periodReports.map((fileName, index) => (
            <li key={index}>
              <a
                href={`/data/REDDEDENLER/${fileName}`}
                download={fileName}
                className="report-link"
              >
                {fileName}
              </a>
            </li>
          ));
        }
        if (typeof periodReports === 'string') {
          return (
            <li key={filters.month}>
              <a
                href={`/data/REDDEDENLER/${periodReports}`}
                download={periodReports}
                className="report-link"
              >
                {periodReports}
              </a>
            </li>
          );
        }
        return <p>Seçilen aya ait rapor bulunamadı.</p>;
      }
      return Object.entries(yearReports).flatMap(([period, report]) => {
        if (Array.isArray(report)) {
          return report.map((fileName, index) => (
            <li key={`${period}-${index}`}>
              <a
                href={`/data/REDDEDENLER/${fileName}`}
                download={fileName}
                className="report-link"
              >
                {fileName}
              </a>
            </li>
          ));
        }
        return (
          <li key={period}>
            <a
              href={`/data/REDDEDENLER/${report}`}
              download={report}
              className="report-link"
            >
              {report}
            </a>
          </li>
        );
      });
    }

    // Diğer projeler için raporları döndür
    if (otherReports[filters.project]) {
      return Object.entries(otherReports[filters.project] || {}).map(([reportName, fileName], index) => (
        <li key={index}>
          <a
            href={`/data/${filters.project.toUpperCase()}/${fileName}`}
            download={fileName}
            className="report-link"
          >
            {reportName}
          </a>
        </li>
      ));
    }

    return null;
  };




  return (
    <div style={{ padding: '20px' }}>
      <h2>Geçmiş Verileri Görüntülemek İçin Lütfen Filtreleri Kullanın</h2>
      <br></br>
      <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
        <div>
          <label htmlFor="project" style={{ marginRight: "10px" }}>Proje: </label>
          <select
            id="project"
            name="project"
            value={filters.project}
            onChange={handleFilterChange}
          >
            <option value="">---Proje Seçin---</option>
            <option value="Audit">Audit</option>
            <option value="Eurorepar">Eurorepar</option>
            <option value="Gizli Müşteri Telefon">Gizli Müşteri Telefon</option>
            <option value="Gizli Müşteri Ziyaret - Satış">Gizli Müşteri Ziyaret - Satış</option>
            <option value="Gizli Müşteri Ziyaret - Servis">Gizli Müşteri Ziyaret - Servis</option>
            <option value="LCV - Satış">LCV - Satış</option>
            <option value="LCV - Servis">LCV - Servis</option>
            <option value="Reddedenler">Reddedenler</option>
          </select>
        </div>


        <div>
          <label htmlFor="brand" style={{ marginRight: "10px" }}>Marka: </label>
          <select
            id="brand"
            name="brand"
            value={filters.brand}
            onChange={handleFilterChange}
            disabled={
              filters.project !== 'Gizli Müşteri Telefon' &&
              filters.project !== 'Gizli Müşteri Ziyaret - Satış' &&
              filters.project !== 'Gizli Müşteri Ziyaret - Servis' &&
              filters.project !== 'LCV - Satış' &&
              filters.project !== 'LCV - Servis'&&
              filters.project !== 'Reddedenler'
            }
          >
            <option value="">---Marka Seçin---</option>
            {filters.project === 'Eurorepar' &&
              Object.keys(euroreparReports).map((brand) => (
                <option key={brand} value={brand}>
                  {brand}
                </option>
              ))}
            {filters.project === 'Gizli Müşteri Telefon' &&
              Object.keys(gizliMusteriTelefonReports).map((brand) => (
                <option key={brand} value={brand}>
                  {brand}
                </option>
              ))}
            {filters.project === 'Gizli Müşteri Ziyaret - Satış' &&
              Object.keys(gizliMusteriZiyaretSatisReports).map((brand) => (
                <option key={brand} value={brand}>
                  {brand}
                </option>
              ))}
            {filters.project === 'Gizli Müşteri Ziyaret - Servis' &&
              Object.keys(gizliMusteriZiyaretServisReports).map((brand) => (
                <option key={brand} value={brand}>
                  {brand}
                </option>
              ))}
            {filters.project === 'LCV - Satış' &&
              Object.keys(lcvSatisReports).map((brand) => (
                <option key={brand} value={brand}>
                  {brand}
                </option>
              ))}
            {filters.project === 'LCV - Servis' &&
              Object.keys(lcvServisReports).map((brand) => (
                <option key={brand} value={brand}>
                  {brand}
                </option>
              ))}

            {filters.project === 'Reddedenler' &&
              Object.keys(reddedenlerReports).map((brand) => (
                <option key={brand} value={brand}>
                  {brand}
                </option>
              ))}
          </select>




        </div>

        <div>
          <label htmlFor="year" style={{ marginRight: "10px" }}>Yıl: </label>
          <select
            id="year"
            name="year"
            value={filters.year}
            onChange={handleFilterChange}
            disabled={!filters.report && !filters.brand}
          >
            <option value="">---Yıl Seçin---</option>
            {(filters.project === 'LCV - Satış' || filters.project === 'LCV - Servis' || filters.project === 'Reddedenler') ? (
              <>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
              </>
            ) : (
              <>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
              </>
            )}
          </select>
        </div>


        <div>
          <label htmlFor="month" style={{ marginRight: "10px" }}>Ay: </label>
          <select
            id="month"
            name="month"
            value={filters.month}
            onChange={handleFilterChange}
            disabled={!filters.year}
          >
            <option value="">---Ay Seçin---</option>
            {renderMonths()}
          </select>

        </div>
      </div>

      {filters.project === 'Audit' && (
  <div>
    <h3>Geçmiş Veriler</h3>
    <p style={{ fontStyle: 'italic', fontSize: '16px', fontWeight: 'lighter', color: '#d3d3d3' }}>
      İndirmek için raporun üzerine tıklayınız
    </p>
    <ul>
      {auditFiles.map((fileName, index) => (
        <li key={index}>
          <a
            href={`/data/AUDIT/${fileName}`}
            download={fileName}
            className="report-link"
          >
            {fileName}
          </a>
        </li>
      ))}
    </ul>
  </div>
)}


      {filters.project === 'Gizli Müşteri Telefon' && (
        <div>
          <h3>Geçmiş Veriler</h3>
          <p style={{ fontStyle: 'italic', fontSize: '16px', fontWeight: 'lighter', color: '#d3d3d3' }}>
      İndirmek için raporun üzerine tıklayınız
    </p>
          <ul>{renderReports()}</ul>
        </div>
      )}
      {filters.project === 'Gizli Müşteri Ziyaret - Satış' && (
        <div>
          <h3>Geçmiş Veriler</h3>
          <p style={{ fontStyle: 'italic', fontSize: '16px', fontWeight: 'lighter', color: '#d3d3d3' }}>
      İndirmek için raporun üzerine tıklayınız
    </p>
          <ul>{renderReports()}</ul>
        </div>
      )}
      {filters.project === 'Gizli Müşteri Ziyaret - Servis' && (
        <div>
          <h3>Geçmiş Veriler</h3>
          <p style={{ fontStyle: 'italic', fontSize: '16px', fontWeight: 'lighter', color: '#d3d3d3' }}>
      İndirmek için raporun üzerine tıklayınız
    </p>
          <ul>{renderReports()}</ul>
        </div>
      )}
      {filters.project === 'LCV - Satış' && (
        <div>
          <h3>Geçmiş Veriler</h3>
          <p style={{ fontStyle: 'italic', fontSize: '16px', fontWeight: 'lighter', color: '#d3d3d3' }}>
      İndirmek için raporun üzerine tıklayınız
    </p>
          <ul>{renderReports()}</ul>
        </div>
      )}
      {filters.project === 'LCV - Servis' && (
        <div>
          <h3>Geçmiş Veriler</h3>
          <p style={{ fontStyle: 'italic', fontSize: '16px', fontWeight: 'lighter', color: '#d3d3d3' }}>
      İndirmek için raporun üzerine tıklayınız
    </p>
          <ul>{renderReports()}</ul>
        </div>
      )}
            {filters.project === 'Reddedenler' && (
        <div>
          <h3>Geçmiş Veriler</h3>
          <p style={{ fontStyle: 'italic', fontSize: '16px', fontWeight: 'lighter', color: '#d3d3d3' }}>
      İndirmek için raporun üzerine tıklayınız
    </p>
          <ul>{renderReports()}</ul>
        </div>
      )}

      {filters.project && filters.report && (
        <div>
          <h3>Geçmiş Veriler</h3>
          <p style={{ fontStyle: 'italic', fontSize: '16px', fontWeight: 'lighter', color: '#d3d3d3' }}>
      İndirmek için raporun üzerine tıklayınız
    </p>
          <ul>{renderReports()}</ul>
        </div>
      )}

    </div>
  );
};

export default OldData;